module.exports = __webpack_public_path__ + "04_long_brown.dbcb5626.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/04_long_brown.png
// module id = Ec9h
// module chunks = 0